import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { Router } from '@angular/router';
import {
  UserLogin_Auth,
  UserLogin_AzureAuth,
  UserLogin_Create,
  UserLogin_Delete,
  UserLogin_GenerateOtp,
  UserLogin_GenerateMobileOtp,
  UserLogin_ValidateMobileOtp,
  UserLogin_ReadByUserId,
  UserLogin_Update,
  UserLogin_ValidateOtp,
  UserLogin_ValidatePassword,
  UserLogin_ValidateToken,
  UserLogin_ValidateUserName
} from '../GlobalVariable';

import {
  AuthenticationRequest,
  AzureUserLoginDTO,
  UserLoginAuthResponseDTO,
  UserLoginCreateRequestDTO,
  UserLoginDeleteRequestDTO,
  UserLoginDTO,
  UserLoginGenerateOtpRequestDTO,
  UserLoginGenerateOtpResponseDTO,
  UserLoginReadByUserIdRequestDTO,
  UserLoginResponseDTO,
  UserLoginUpdateRequestDTO,
  UserLoginValidateOtpRequestDTO,
  UserLoginValidatePasswordRequestDTO,
  UserLoginValidatePasswordResponseDTO,
  UserLoginValidateUserNameRequestDTO,
  ValidationResponse
} from './userlogin.interface';
import { UserSharedService } from '../Shared Utilities/user-shared.service';

@Injectable({
  providedIn: 'root'
})
export class UserLoginService {

  constructor(private http: HttpClient, private router: Router, private userShared: UserSharedService) { }
  private readonly _userSubject = new BehaviorSubject<UserLoginResponseDTO | null>(null);
  readonly user$ = this._userSubject.asObservable();
  UserData = {}

  isAuthenticated() {
    if (localStorage.getItem('access_token') != null || localStorage.getItem('access_token') != undefined) {
      return true;
    } else {
      return false
    }
  }

  SignOutUser() {
    localStorage.clear();
    this._userSubject.next(null);
    this.userShared.setFirstName('');
    this.router.navigate(['/login'])
  }

  saveUserData(data: UserLoginResponseDTO) {
    localStorage.setItem('userObject', encodeURIComponent(JSON.stringify(data)));
    this._userSubject.next(data);
  }

  User(): UserLoginResponseDTO {
    let userObject: any = localStorage.getItem('userObject')
    this.UserData = JSON.parse(decodeURIComponent(userObject))
    return JSON.parse(decodeURIComponent(userObject))
  }

  UserLogin_Create(data: UserLoginCreateRequestDTO): Observable<UserLoginDTO> {
    return this.http.post<UserLoginDTO>(UserLogin_Create, data);
  }

  UserLogin_Update(data: UserLoginUpdateRequestDTO): Observable<UserLoginDTO> {
    return this.http.post<UserLoginDTO>(UserLogin_Update, data);
  }

  UserLogin_Delete(data: UserLoginDeleteRequestDTO): Observable<void> {
    return this.http.post<void>(UserLogin_Delete, data);
  }


  UserLogin_ReadByUserId(data: UserLoginReadByUserIdRequestDTO): Observable<UserLoginDTO> {
    return this.http.post<UserLoginDTO>(UserLogin_ReadByUserId, data);
  }

  UserLogin_ValidateUserName(data: UserLoginValidateUserNameRequestDTO): Observable<ValidationResponse> {
    return this.http.post<ValidationResponse>(UserLogin_ValidateUserName, data);
  }

  UserLogin_Auth(data: AuthenticationRequest): Observable<UserLoginAuthResponseDTO> {
    return this.http.post<UserLoginAuthResponseDTO>(UserLogin_Auth, data);
  }

  UserLogin_AzureAuth(data: AzureUserLoginDTO): Observable<UserLoginDTO> {
    return this.http.post<UserLoginDTO>(UserLogin_AzureAuth, data);
  }

  UserLogin_ValidateToken(): Observable<UserLoginResponseDTO> {
    return this.http.get<UserLoginResponseDTO>(UserLogin_ValidateToken);
  }

  UserLogin_LoginGenerateOtp(data: UserLoginGenerateOtpRequestDTO): Observable<UserLoginGenerateOtpResponseDTO> {
    return this.http.post<UserLoginGenerateOtpResponseDTO>(UserLogin_GenerateOtp, data);
  }

  UserLogin_LoginValidateOtp(data: UserLoginValidateOtpRequestDTO): Observable<UserLoginAuthResponseDTO> {
    return this.http.post<UserLoginAuthResponseDTO>(UserLogin_ValidateOtp, data);
  }

  UserLogin_ValidatePassword(data: UserLoginValidatePasswordRequestDTO): Observable<UserLoginValidatePasswordResponseDTO> {
    return this.http.post<UserLoginValidatePasswordResponseDTO>(UserLogin_ValidatePassword, data);
  }

  UserLogin_GenerateMobileOtp(data: UserLoginGenerateOtpRequestDTO): Observable<UserLoginGenerateOtpResponseDTO> {
    return this.http.post<UserLoginGenerateOtpResponseDTO>(UserLogin_GenerateMobileOtp, data);
  }

  UserLogin_ValidateMobileOtp(data: UserLoginValidateOtpRequestDTO): Observable<UserLoginGenerateOtpResponseDTO> {
    return this.http.post<UserLoginGenerateOtpResponseDTO>(UserLogin_ValidateMobileOtp, data);
  }

}
